<template>
  <v-dialog width="700" v-model="fieldMappingDialog">
    <template v-slot:activator="{ on, attrs }">
        <v-btn :disabled="btnDisabledDetail"     class="btn ml-1"  v-bind="attrs" v-on="on" style="background:#e27070 !important;float:right"   text dark>{{$t('Field Mapping')}}</v-btn>
    </template>
    <v-card class="popup add_store_popup">
      <h3 class="page-title-bar">
        <i class="ico ico-system"></i>{{ $t('Field Mapping') }}
      </h3>
      <v-row>
          <v-col cols="12" sm="6"  class="tbl-type03" style="background-color:#001e38;color:white;text-align:center" >{{$t('MAPPED FIELD')}}</v-col>
          <v-col cols="12" sm="6" class="tbl-type03" style="background-color:#001e38;color:white;text-align:center">{{$t('SELECTED FIELD')}}</v-col>
      </v-row>
      <v-row class="" v-for="item in getInitialData" :key="item.id">

          <v-col cols="12" sm="6" class="padding-0" >
            <v-btn class="btnClass" style="width:100%;cursor:default">{{item.name}}<span v-if="item.clearable===false" style="color:red">*</span></v-btn>
            </v-col>
          <v-col cols="12" sm="6" class="padding-0">
            <v-autocomplete   class="grey lighten-2"  outlined prepend-inner-icon="mdi-search-web" @change="editFieldname(item,item.value)"  hide-details   v-model="item.value"  :items="getSelectedField.standardDataMapList" :clearable="item.clearable" @keydown="clearTabindex"></v-autocomplete>
            </v-col>
      </v-row>

      <v-card-actions class="d-flex justify-center">
        <v-btn text icon @click="saveFiledMapping" :disabled="btnDisabledDetail" class="btn">{{
          $t('Save')
        }}</v-btn>
        <v-btn text icon @click="fieldMappingDialog=false"   class="btn">{{
          $t('Cancel')
        }}</v-btn>
      </v-card-actions>
    </v-card>
    <!-- <msg-box :msgBox="msgBox" @closeMsgBox="closeMsgBox" /> -->
  </v-dialog>
</template>
<script>
// Utils
import EventBus from '@/plugins/eventBus'
import configs from '@/plugins/configs'

const requests = {

  saveFieldList: {
    method: 'POST',
    url: '/common/standardDataMap'
  }

}
export default {
  name: 'CustomerInfoAdd',
  props: {
    getSelectedField: [Array, Object]
  },
  data () {
    return {
      fieldMappingDialog: false,
      btnDisabledDetail: null,
      loadAllFieldList: [],
      mappedFieldList: [
        { name: 'Store Code', key: 'mappedStationCode', clearable: false },
        { name: 'Product ID', key: 'mappedArticleId', clearable: false },
        { name: 'Product Name', key: 'mappedArticleName', clearable: true },
        { name: 'NFC', key: 'mappedNfc', clearable: true },
        { name: 'Original Price', key: 'mappedOriginPrice', clearable: true },
        { name: 'Sale Price', key: 'mappedSalePrice', clearable: true },
        { name: 'Discount Percentage', key: 'mappedDiscountPercentage', clearable: true },
        { name: 'Reserved One', key: 'mappedReservedOne', clearable: true },
        { name: 'Reserved Two', key: 'mappedReservedTwo', clearable: true },
        { name: 'Reserved Three', key: 'mappedReservedThree', clearable: true }

      ]

    }
  },
  mounted () {
    this.$store.dispatch('auth/getDisabledBtn', '9500').then(flag => {
      this.btnDisabledDetail = flag
    })
  },
  computed: {
    tableHeaders () {
      return [
        {
          text: this.$t('Mapped filed'),
          sortable: false,
          align: 'center',
          value: 'id'
        },
        {
          text: this.$t('Selected filed'),
          sortable: false,
          align: 'center',
          value: 'itemname'
        }
      ]
    },

    getInitialData () {
      this.mappedFieldList.forEach((element, i) => {
        this.mappedFieldList[i].value = this.getSelectedField[element.key]
      })
      return this.mappedFieldList
    }
  },
  methods: {
    clearTabindex () {
      var elements = document.getElementsByClassName('v-icon')
      for (let i = 0; i < elements.length; i++) {
        elements[i].setAttribute('tabindex', '-1')
      }
    },
    editFieldname (item, value) {
      if (value !== null && value !== 'null' && value !== undefined && value !== 'undefined') {
        this.getSelectedField[item.key] = value
      } else {
        this.getSelectedField[item.key] = value = ''
      }
    },
    saveFiledMapping () {
      const config = this.getSelectedField
      var url = configs.ApiUrl + requests.saveFieldList.url
      this.$utils.callAxiosWithBody(requests.saveFieldList.method, url, config).then(res => {
        this.fieldMappingDialog = false
        if (res.status === 200) {
          EventBus.$emit('messageAlert', this.$t('The data has been saved successfully'))
          this.$emit('fieldMappingload', true)
        } else if (res.status === 400) {
          EventBus.$emit('messageAlert', this.$t('Invalid parameter'))
        } else {
          EventBus.$emit('messageAlert', this.$t('Failed to save data.'))
        }
      })
        .catch(error => {
          EventBus.$emit('messageAlert', this.$t('Failed to save data.'))
          console.log(error)
        })
    }
  }
}
</script>
<style scoped>
.btnClass{
  height: 55px !important;
}
.padding-0{
    padding-right:0;
    padding-left:0;
    padding-bottom: 0;
}

</style>
